import React from "react";
import { BaseFieldProps } from "./BaseFieldProps";
import { OIDCUrlField } from "./OIDCUrlField";

export const AuthorizationURLField = ({ disabled = false, onChange, value = "" }: BaseFieldProps) => {
    return (
        <OIDCUrlField
            id="authorization-url"
            label="Authorization URL"
            placeholder="Authorization URL"
            description="URL of the OAuth 2.0 Authorization Endpoint"
            examples={["(i.e. https://idp.example.com/oauth2/authorize)"]}
            disabled={disabled}
            onChange={onChange}
            value={value}
        />
    );
};

AuthorizationURLField.displayName = "AuthorizationURLField";
